import { createReducer, on } from '@ngrx/store';

import { SharedActions } from './shared.actions';

export const sharedStateKey = 'shared';

export interface ISharedState {
  loginInProgress: boolean;
}

export const initialSharedState: ISharedState = {
  loginInProgress: false,
};

export const sharedReducer = createReducer(
  initialSharedState,
  on(
    SharedActions.login,
    (state): ISharedState => ({ ...state, loginInProgress: true })
  ),
  on(
    SharedActions.loginSuccess,
    SharedActions.loginFailure,
    (state): ISharedState => ({
      ...state,
      loginInProgress: false,
    })
  )
);
